// @flow

import PropTypes      from 'prop-types';
import * as React     from 'react';
import withSideEffect from 'react-side-effect';

function reducePropsToState(propsList) {
  const innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps;
  }
}

function handleStateChangeOnClient({description, keywords} = {}) {
  updateMeta('description', description || '');
  updateMeta('keywords', keywords || '');
}

function updateMeta(tagName, nextContent) {

  let metaTag: HTMLMetaElement =
        // $FlowFixMe
        document.querySelector(`meta[name="${tagName}"]`);

  if (metaTag && !nextContent) {
    document.getElementsByTagName('head')[0].removeChild(metaTag);
  }

  const needsToBeAdded = !metaTag;

  if (needsToBeAdded) {
    metaTag      = document.createElement('meta');
    metaTag.name = tagName;
  }

  if (metaTag.content !== nextContent) {
    metaTag.content = nextContent;
  }

  if (needsToBeAdded && !!nextContent) {
    document.getElementsByTagName('head')[0].appendChild(metaTag);
  }
}

function DocumentSeo() {
}

DocumentSeo.prototype = Object.create(React.Component.prototype);

DocumentSeo.displayName = 'DocumentSeo';
DocumentSeo.propTypes   = {
  description: PropTypes.string.isRequired,
  keywords:    PropTypes.string.isRequired,
};

DocumentSeo.prototype.render = function () {
  if (this.props.children) {
    return React.Children.only(this.props.children);
  } else {
    return null;
  }
};

DocumentSeo = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
)(DocumentSeo);

export default DocumentSeo;



// WEBPACK FOOTER //
// ./src/components/page_elements/DocumentSeo.js